import { addDays, subDays } from 'date-fns';
import { Box, Flex } from '@chakra-ui/react';
import Cookies from 'universal-cookie';
import moment from 'moment';

import FilterDateRangePickerMobile from 'UiKit/filter-date-range-picker-mobile';
import { ChevronLeftIcon, ChevronRightIcon } from 'Asset/icon';
import { TextSemiBold } from 'UiKit/typography';

import FilterTabMobile from 'UiKit/filter-tab-mobile';

import getStartDayWithTimeZone from 'View/host-schedule/helper/getStartDayWithTimezone';
import getEndDayWithTimeZone from 'View/host-schedule/helper/getEndDayWithTimezone';
import { useHostScheduleState } from 'View/host-schedule/state';
import getDateRangeText from 'View/host-schedule/helper/getDateRangeText';

import { viewTypeOptions } from './const';
import styles from './styles.module.css';
import getDateConstraint from 'View/host-schedule/helper/getDateConstraint';

const FilterCalendar = () => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  const { filterState, updateFilterState } = useHostScheduleState();

  const onChangeCalendarType = (calendarType) => {
    const endDate = getEndDayWithTimeZone(addDays(filterState?.dateRangeCalendar?.startDate, calendarType?.value - 1));
    const startDate = getStartDayWithTimeZone(filterState?.dateRangeCalendar?.startDate);

    updateFilterState({ calendarType, dateRangeCalendar: { startDate, endDate: endDate } });
  };

  const onChangeDateRange = ({ startDate, endDate }) => {
    const newStartDate = getStartDayWithTimeZone(startDate);
    const newEndDate = getEndDayWithTimeZone(endDate);

    updateFilterState({ dateRangeCalendar: { startDate: newStartDate, endDate: newEndDate } });
  };

  const onClickArrow = (type) => {
    let startDate;
    let endDate;

    switch (type) {
      case 'next':
        startDate = getStartDayWithTimeZone(addDays(filterState?.dateRangeCalendar?.endDate, 1));
        endDate = getEndDayWithTimeZone(addDays(filterState?.dateRangeCalendar?.endDate, filterState?.calendarType?.value));
        break;

      default:
        startDate = getStartDayWithTimeZone(subDays(filterState?.dateRangeCalendar?.startDate, filterState?.calendarType?.value));
        endDate = getEndDayWithTimeZone(subDays(filterState?.dateRangeCalendar?.endDate, filterState?.calendarType?.value));
        break;
    }

    updateFilterState({ dateRangeCalendar: { startDate, endDate } });
  };

  const selectedDateRange = getDateRangeText(filterState?.dateRangeCalendar);
  const dateConstraint = getDateConstraint();

  const selectedStartDate = moment.tz(filterState?.dateRangeCalendar?.startDate, timezone).format('YYYY-MM-DD');
  const selectedEndDate = moment.tz(filterState?.dateRangeCalendar?.endDate, timezone).format('YYYY-MM-DD');

  return (
    <Box className={styles['schedule__filter']}>
      <Box className={styles['top__section']}>
        <FilterTabMobile items={viewTypeOptions} onChange={onChangeCalendarType} label={'Views:'} selected={filterState?.calendarType} />

        <FilterDateRangePickerMobile
          minDate={dateConstraint?.minDate}
          maxDate={dateConstraint?.maxDate}
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          onChange={onChangeDateRange}
          dateOffset={filterState?.calendarType?.value}
        />
      </Box>

      <Box className={styles['bottom__section']}>
        <Flex className={styles['arrow__container']}>
          <ChevronLeftIcon size="14px" color="var(--color-semantic-text)" onClick={() => onClickArrow('prev')} />
        </Flex>

        <TextSemiBold className={styles['daterange__text']}>{selectedDateRange}</TextSemiBold>

        <Flex className={styles['arrow__container']}>
          <ChevronRightIcon size="14px" color="var(--color-semantic-text)" onClick={() => onClickArrow('next')} />
        </Flex>
      </Box>
    </Box>
  );
};

export default FilterCalendar;
